/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Hotel_Hero_CtaInputs */

const en_hotel_hero_cta = /** @type {(inputs: Hotel_Hero_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create your rap video`)
};

/**
* | output |
* | --- |
* | "Create your rap video" |
*
* @param {Hotel_Hero_CtaInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const hotel_hero_cta = /** @type {((inputs?: Hotel_Hero_CtaInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Hotel_Hero_CtaInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_hotel_hero_cta(inputs)
});
export { hotel_hero_cta as "hotel.hero.cta" }